var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"avatar",style:({ backgroundImage: ("url('" + _vm.avatar + "')") }),on:{"click":function($event){return _vm.handleClickEvent($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }